module.exports = __webpack_public_path__ + "static/media/financial-activities.70e92eeb.svg";